/*
  MOMERY CUSTOM: Kategorie-Menü auf dem Handy.

  Zwei Darstellungen (siehe snippets/momery-mobile-menu.liquid):

  1. Gruppen mit Unterseiten ([data-momery-mm2]): Ein Tipp auf eine Zeile mit
     Unterpunkten zeigt deren Unterseite, "Zurück" führt zur Übersicht. Ohne
     JavaScript erledigt das der Sprunganker (:target im CSS). Beim Schließen des
     Menüs springt es zurück auf die Übersicht.

  2. Aufklapp-Liste ([data-momery-mm], Rückfall): Immer nur ein Hauptbereich offen.
     Neue Browser erledigen das über das gemeinsame name-Attribut der <details>;
     dieses Skript schließt in älteren Browsern die anderen Bereiche. Außerdem hält
     es Habitats Klasse "submenu-open" passend zum echten Zustand und holt einen
     geöffneten Bereich ins Bild, falls er nach oben aus dem Menü gerutscht ist.
*/
(function () {
  var DETAILS = 'details.momery-mm__details';

  function initPanels(root) {
    if (root.hasAttribute('data-momery-mm2-ready')) return;
    root.setAttribute('data-momery-mm2-ready', '');

    var drawer = root.closest('.mobile-menu-drawer');
    var wrapper = root.closest('.mobile-toggle-wrapper');
    var opener = null;
    var scrollBefore = 0;

    function closeAll() {
      var open = root.querySelectorAll('[data-mm2-sub].is-open');
      for (var i = 0; i < open.length; i++) open[i].classList.remove('is-open');
      root.classList.remove('is-sub');
    }

    function show(sub, trigger) {
      if (!sub) return;
      closeAll();
      opener = trigger;
      scrollBefore = drawer ? drawer.scrollTop : 0;
      sub.classList.add('is-open');
      root.classList.add('is-sub');
      if (drawer) drawer.scrollTop = 0;
      var back = sub.querySelector('[data-mm2-back]');
      if (back) back.focus({ preventScroll: true });
    }

    function back(restoreFocus) {
      closeAll();
      if (drawer) drawer.scrollTop = restoreFocus ? scrollBefore : 0;
      if (restoreFocus && opener) opener.focus({ preventScroll: true });
      opener = null;
    }

    root.addEventListener('click', function (event) {
      var open = event.target.closest('[data-mm2-open]');
      if (open) {
        event.preventDefault();
        show(document.getElementById(open.getAttribute('data-mm2-open')), open);
        return;
      }
      if (event.target.closest('[data-mm2-back]')) {
        event.preventDefault();
        back(true);
      }
    });

    // Menü auf: Bilder der Unterseiten vorab laden, damit sie beim Antippen da sind.
    // Menü zu: beim nächsten Öffnen wieder mit der Übersicht starten.
    if (wrapper) {
      wrapper.addEventListener('toggle', function () {
        if (!wrapper.open) {
          back(false);
          return;
        }
        var images = root.querySelectorAll('[data-mm2-sub] img[loading="lazy"]');
        for (var i = 0; i < images.length; i++) images[i].loading = 'eager';
      });
      // Habitat entfernt "open" erst nach der Schließ-Animation. Wird vorher wieder
      // geöffnet, kommt kein toggle: deshalb auch beim Öffnen-Klick zurücksetzen.
      var button = wrapper.querySelector('.mobile-toggle');
      if (button) {
        button.addEventListener('click', function () {
          if (!wrapper.classList.contains('active')) back(false);
        });
      }
    }
  }

  function initAccordion(list) {
    if (list.hasAttribute('data-momery-mm-ready')) return;
    list.setAttribute('data-momery-mm-ready', '');

    // "toggle" steigt nicht auf, deshalb in der Capture-Phase lauschen.
    list.addEventListener(
      'toggle',
      function (event) {
        var opened = event.target;
        if (!opened.matches || !opened.matches(DETAILS)) return;

        var all = list.querySelectorAll(DETAILS);
        for (var i = 0; i < all.length; i++) {
          if (opened.open && all[i] !== opened && all[i].open) all[i].open = false;
          all[i].classList.toggle('submenu-open', all[i].open);
        }

        if (opened.open) {
          var summary = opened.querySelector('summary');
          var drawer = list.closest('.mobile-menu-drawer');
          requestAnimationFrame(function () {
            var top = drawer ? drawer.getBoundingClientRect().top : 0;
            if (summary.getBoundingClientRect().top < top) summary.scrollIntoView({ block: 'nearest' });
          });
        }
      },
      true
    );
  }

  function run() {
    var panels = document.querySelectorAll('[data-momery-mm2]');
    for (var i = 0; i < panels.length; i++) initPanels(panels[i]);
    var lists = document.querySelectorAll('[data-momery-mm]');
    for (var j = 0; j < lists.length; j++) initAccordion(lists[j]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', run);
})();
